import script from "./forgot-password.vue?vue&type=script&setup=true&lang=js"
export * from "./forgot-password.vue?vue&type=script&setup=true&lang=js"

import "./forgot-password.vue?vue&type=style&index=0&id=4231d9d2&lang=css"

const __exports__ = script;

export default __exports__